export default "__VITE_ASSET__DUEwYMHl__"